__turbopack_context__.v({
  "trustindexCustomPromo": "miniReviewStylingOverride-module__qFyUUq__trustindexCustomPromo",
});
